import { z } from 'zod'

export const clientLevelSchema = z.enum(['1', '2', '3', '4'])

export type ClientLevel = z.infer<typeof clientLevelSchema>

export const clientLevelNameSchema = z.enum([
  'Nivel 1 - Bronce',
  'Nivel 2 - Plata',
  'Nivel 3 - Oro',
  'Nivel 4 - Diamante'
])

export type ClientLevelName = z.infer<typeof clientLevelNameSchema>
